import { styled } from '@mui/material/styles';
import {
    Paper,
} from '@mui/material';

export const DashboardCard = styled(Paper)({
    padding: '25px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
});

export const CardHeader = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const CardTitle = styled('h3')({
    fontSize: '1.1rem',
    fontWeight: 500,
    margin: 0,
    color: 'var(--primary-main)',
});